const _TemplatesGroupedByTheme =
{
	/* EDIT THEME - Interactive mode for browsers */
	Edit: [
		{
			HashPostfix: `-Template-Input-InputType-MaterialsHiddenTestInjector`,
			DefaultInputExtensions: [ 'MaterialsTestInjectorPicker' ],
			Template: /*HTML*/`
			<!-- InputType MaterialsHiddenTestInjector {~D:Record.Hash~} {~D:Record.DataType~} -->
			<input
				id="MATERIALS-ENTITY-TRACKING-GUID-{~D:Record.Macro.RawHTMLID~}"
				type="hidden"
				tabindex="-1"
				value=""
			/>`,
		},
		{
			HashPostfix: '-TabularTemplate-Begin-Input-InputType-MaterialsHiddenTestInjector',
			DefaultInputExtensions: [ 'MaterialsTestInjectorPicker' ],
			Template: /*HTML-Partial*/`
			<!-- InputType MaterialsHiddenTestInjector {~D:Record.Hash~} {~D:Record.DataType~} -->
			<input
				id="MATERIALS-ENTITY-TRACKING-GUID-{~D:Record.Macro.RawHTMLID~}-{~D:Context[2].Key~}"
				type="hidden"
				tabindex="-1"
				value=""
			/>
			<input
				id="MATERIALS-ENTITY-SELECT-TABULAR-DATA-{~D:Record.Macro.RawHTMLID~}-{~D:Context[2].Key~}"
				type="hidden"
				tabindex="-1"
				{~D:Record.Macro.InformaryTabular~} `,
		},
		{
			HashPostfix: '-TabularTemplate-End-Input-InputType-MaterialsHiddenTestInjector',
			DefaultInputExtensions: [ 'MaterialsTestInjectorPicker' ],
			Template: /*HTML-Partial*/`
				value="" />`,
		},
	],
	/* READ THEME - Interactive mode for browsers in a locked/disabled/readonly state */
	Read: [
		{
			HashPostfix: `-Template-Input-InputType-MaterialsHiddenTestInjector`,
			DefaultInputExtensions: [ 'PickerDisplay' ],
			Template: /*HTML*/`
			<!-- InputType MaterialsHiddenTestInjector {~D:Record.Hash~} {~D:Record.DataType~} -->
			<input
				id="MATERIALS-ENTITY-TRACKING-GUID-{~D:Record.Macro.RawHTMLID~}"
				type="hidden"
				tabindex="-1"
				value=""
			/>`,
		},
		{
			HashPostfix: `-TabularTemplate-Begin-Input-InputType-MaterialsHiddenTestInjector`,
			DefaultInputExtensions: [ 'PickerDisplay' ],
			Template: /*HTML-Partial*/`
			<!-- InputType MaterialsHiddenTestInjector {~D:Record.Hash~} {~D:Record.DataType~} -->
			<input
				id="MATERIALS-ENTITY-TRACKING-GUID-{~D:Record.Macro.RawHTMLID~}-{~D:Context[2].Key~}"
				type="hidden"
				tabindex="-1"
				value=""
			/>
			<input
				id="MATERIALS-ENTITY-DISPLAY-TABULAR-DATA-{~D:Record.Macro.RawHTMLID~}-{~D:Context[2].Key~}"
				type="hidden"
				class="input"
				{~D:Record.Macro.HTMLName~}
				{~D:Record.Macro.InformaryTabular~}
				disabled="disabled" `,
		},
		{
			HashPostfix: '-TabularTemplate-End-Input-InputType-MaterialsHiddenTestInjector',
			Template: /*HTML-Partial*/`
				value="" />
			`,
		},
	],
	/* PRINT THEME - Non-interactive mode for PDF documents */
	Print: [
		{
			HashPostfix: `-Template-Input-InputType-MaterialsHiddenTestInjector`,
			DefaultInputExtensions: [ 'PickerDisplay' ],
			Template: /*HTML*/`
			<!-- InputType MaterialsHiddenTestInjector {~D:Record.Hash~} {~D:Record.DataType~} -->
			<input
				id="MATERIALS-ENTITY-TRACKING-GUID-{~D:Record.Macro.RawHTMLID~}"
				type="hidden"
				tabindex="-1"
				value=""
			/>`,
		},
		{
			HashPostfix: `-TabularTemplate-Begin-Input-InputType-MaterialsHiddenTestInjector`,
			DefaultInputExtensions: [ 'PickerDisplay' ],
			Template: /*HTML-Partial*/`
			<!-- InputType MaterialsHiddenTestInjector {~D:Record.Hash~} {~D:Record.DataType~} -->
			<input
				id="MATERIALS-ENTITY-TRACKING-GUID-{~D:Record.Macro.RawHTMLID~}-{~D:Context[2].Key~}"
				type="hidden"
				tabindex="-1"
				value=""
			/>
			<div
				style="display: none;"
				id="MATERIALS-ENTITY-DISPLAY-TABULAR-DATA-{~D:Record.Macro.RawHTMLID~}-{~D:Context[2].Key~}"
				{~D:Record.Macro.HTMLName~}
				{~D:Record.Macro.InformaryTabular~}
			`,
		},
		{
			HashPostfix: '-TabularTemplate-End-Input-InputType-MaterialsHiddenTestInjector',
			Template: /*HTML-Partial*/`
			></div>
			`,
		},
	],
};

module.exports = _TemplatesGroupedByTheme;
